import { Component, OnInit } from "@angular/core";
import { RedirectCleanupService } from "src/app/shared/services/redirectCleanUp.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {
  constructor(private redirectCleanup: RedirectCleanupService) {}

  ngOnInit(): void {

    setTimeout(() => {
      // localStorage.removeItem('redirect');

      this.redirectCleanup.clearOnce();
    }, 3000); // even 0ms can work, but 100ms is safe

    
  }

}
